<div class="flex min-h-dvh flex-col justify-center items-center px-5 sm:px-0">
  <div class="w-full max-w-[600px] text-center bg-white rounded-2xl px-8 py-10  shadow-custom transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg">

    <img src="../../../assets/img/green_check.svg" alt="Logo" class="w-20 m-auto" />

    <div class="my-5">
      <h2 class="text-[#008000] font-semibold text-4xl">Thank You!</h2>
      <p class="font-semibold text-2xl mb-3">For submitting your feedback!</p>
    </div>
  </div>
</div>
